export default {
    products: null,
    purchasesModel: false,
    loading: false,
}